export default "__VITE_ASSET__Dn0dvHUW__"